<template>
    <svg
        class="loading-bar"
        width="450px"
        height="3px"
        version="1.1"
        :style="{display: visible ? 'block' : 'none'}"
    >
        <path fill="transparent" stroke="#fff" stroke-width="4" d="m0 0, 450 0" class="path"></path>
        <path fill="transparent" stroke="#00A9BA" stroke-width="4" d="m0 0, 450 0"></path>
        <path fill="transparent" stroke="#fff" stroke-width="4" d="m0 0, 450 0" class="line1"></path>
    </svg>
</template>

<script>
export default {
    props: {
        visible: {
            type: Boolean,
            default: false
        }
    }
};
</script>

<style lang="scss" scoped>
.loading-bar {
    width: 450px;
    height: 3px;
    display: block;
    position: absolute;

    .path {
        width: 100%;
    }
    .line1 {
        stroke-dasharray: 80, 100;
        stroke-dashoffset: 70;
        animation: loading-dash 1.5s linear alternate-reverse infinite;
    }

    @keyframes loading-dash {
        from {
            stroke-dashoffset: 360;
        }
        to {
            stroke-dashoffset: 40;
        }
    }
}
</style>



// WEBPACK FOOTER //
// src/components/loading/LoadingBar.vue